import React, {useState, useEffect, useContext} from 'react';
import {FormattedMessage} from 'react-intl';
import { Auth } from 'aws-amplify';
import { currentLang, currentLangParam } from '../../components/components/utils';
import AppContext from '../../components/AppContext';
import MagnifiquePopup from '../../components/MagnifiquePopup.js'
import Spinner from '../../components/Spinner';
import PopupLink from '../../templates/PopupLink.js';

//This page loads as a default while the authentication check is happening.
//If not authorized, it auto-redirects to the login page
//If authorized, it auto-redirects to the callback page
function SecureEFilingSplash({navigation}) {
	const appContext = useContext(AppContext);
	const [displayPopup, setDisplayPopup] = useState(false);
	const [alreadyAuthenticated, setAlreadyAuthenticated] = useState(false);

	useEffect(() => {

		async function fetchData() {
			await validateUser();
		}

		fetchData();

	}, []);


	const navigateForward = () => {
		if (alreadyAuthenticated) {
			navigation.navigate("Callback", currentLangParam());
		} else {
			navigation.navigate("Login", currentLangParam());
		}
	}

	async function validateUser() {

		appContext.setGlobalSpinnerCount(appContext.globalSpinnerCount + 1);

		await Auth.currentAuthenticatedUser().then(() => {

			if (!appContext.existingUser) {
				setAlreadyAuthenticated(true);

			} else if (!appContext.codeTables) {
				localStorage.setItem("activeKey", "SecureEFiling")
				navigation.navigate("Callback", currentLangParam());
			} else {
				navigation.navigate("SecureEFiling", currentLangParam());
			}
		}).catch((error) => {
			localStorage.setItem("activeKey", "SecureEFiling");
		}).finally(() => {
			setDisplayPopup(true);
			appContext.setGlobalSpinnerCount(Math.max(appContext.globalSpinnerCount - 1, 0));
		});
	}


	return (
		<>
		  <MagnifiquePopup
		    id="continueLoginConfirmation"
		    trigger={displayPopup}
		    setTrigger={setDisplayPopup}
		    continueCallback={navigateForward}
		    cancelCallback={() => {window.location.replace("https://www.cbsa-asfc.gc.ca/sima-lmsi/menu-eng.html");}}
		    header={<><FormattedMessage id="message.login.confirmation" /></>}
		    body={<FormattedMessage id="message.login.explanation" values={{p: (chunks) => <p>{chunks}</p>, b: (chunks) => <b>{chunks}</b>}} />}
		  />
		  <Spinner show={true} />
		</>
	);
}


SecureEFilingSplash.path = "secure-e-filing-depot-electronique-securise";
SecureEFilingSplash.navigationOptions = {
	pageTitle: ""
	, breadcrumb: [
		<PopupLink url={window.env["canada-url"][currentLang()]}><FormattedMessage id="breadcrumb.Canada.text" /></PopupLink>
		, <PopupLink url={window.env["cbsa-breadcrumbs-url"][currentLang()]}><FormattedMessage id="breadcrumb.CBSA.text" /></PopupLink>
		, <PopupLink url={window.env["cbsa-sima-breadcrumbs-url"][currentLang()]}><FormattedMessage id="breadcrumb.ACE.text" /></PopupLink>

	]
	, breadcrumbTitle: <FormattedMessage id="breadcrumbs.acePortal"/>
};

export default SecureEFilingSplash;